import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import gameActions from '../store/actions/gameActions'
import NarrativeScreen from '../components/narrative/NarrativeScreen'
import cutsceneInicial from '../narratives/cutscene-inicial.json'
import AnimationLayout from '../components/AnimationLayout'
import MatildeBalloon from '../components/MatildeBalloon'
import { isLoaded, isEmpty } from 'react-redux-firebase'

const Dashboard = () => {
    const dispatch = useDispatch()
    const gameState = useSelector(state => state.game)
    const userInfo = useSelector(state => state.firebase.profile)
    const auth = useSelector(state => state.firebase.auth)

    const { username } = userInfo

    useEffect(() => {
        if (isLoaded(auth) && !isEmpty(auth) && !userInfo.isEmpty && userInfo?.travels?.completedTravels.length === 0) {
            dispatch(gameActions.makeNarrative(cutsceneInicial, 'cutscene-inicial'))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const mainDashLinks = [
        ['Viajar', '/viajar', 'menu-travel'],
        ['Mundo em Notícias', '/mundo-em-noticias', 'menu-worldnews'],
    ]

    return (
        !userInfo?.travels?.completedTravels.length && gameState.narrative ? <NarrativeScreen /> :
            <AnimationLayout>
                <MatildeBalloon>
                    <h3 className='p-0'>Olá {username}!</h3>
                    <p className='text-left'>
                        O meu nome é Matilde e estou pronta para embarcar numa aventura por diversos países e com todos os cuidados de saúde necessários. Escolha viajar ou embarcar no mundo em notícias.
                    </p>
                </MatildeBalloon>
                <section id='dashboard'>
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 md:gap-8 lg:gap-12 mb-10">
                        {mainDashLinks.map((item, index) =>
                            <Link key={index} to={`${item[1]}`} className="image-button usable w-full flex flex-col items-center justify-center">
                                <img alt={item[0]} className='object-contain' src={`${require(`../assets/img/${item[2]}.png`)}`} />
                                <h2>{item[0]}</h2>
                            </Link>
                        )}
                    </div>
                </section>
            </AnimationLayout >
    )
}

export default Dashboard